import * as Cookies from 'js-cookie';
import { call, takeEvery } from 'redux-saga/effects';

import * as abTestActions from '~/actions/ab-test.actions';
import { ActionKeys } from '~/actions/constants';

const cookies = Cookies.withConverter({
  write: (value) => `"${value}"`,
});

export function* setABCookie(action: ReturnType<typeof abTestActions.setABCookie>) {
  try {
    yield call(cookies.set, action.payload.name, action.payload.content, {
      domain: CONFIG.shippoRootUrl,
    });
  } catch (err) {
    // todo: raise error in log
  }
}

export default [takeEvery(ActionKeys.SET_AB_COOKIE, setABCookie)];
